import React, { createContext } from "react";

export const AppContext = createContext();
export function AppContextProvider(props) {
  return (
    <AppContext.Provider
      value={{
        setMessage: props.setMessage, //should this be its own provider?
        shopDomain: props.shop_domain,
        proxyPath: props.proxy_path,
        mapboxAdminToken: props.mapbox_admin_token,
        isProduction: props.production,
        shopDetails: props.shop_details,
        plan: props.plan,
        apiKey: props.api_key,
        host: props.host,
        appProxyLandingURL: props.app_proxy_landing_url,
        appProxyDirectoryURL: props.app_proxy_directory_url,
        enabledFeatures: props.enabled_features,
        languageTranslateIconUrl: props.language_translate_icon_url,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
}
